import {
  TagGroupSchema,
  UpdateTagGroupInputSchema_,
} from "@redotech/redo-model/support/tag-group-zod-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateTagGroup = {
  name: "updateTagGroup" as const,
  input: z.object({
    ...UpdateTagGroupInputSchema_.shape,
    tagsToAdd: z.array(zExt.objectId()).optional(),
    tagsToRemove: z.array(zExt.objectId()).optional(),
  }),
  output: z.object({ tagGroup: TagGroupSchema }),
};
